import { Blog } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import { useTranslations } from 'next-intl';
import AppLink from '@/components/common/AppLink';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';
import { blogBg } from '@/functions/formats';
import UserInfo from '@/components/pages/home/HomeContent/SampleBlogs/BlogCard/BlogFooter/UserInfo';
import Button from '@/components/common/Button';

export default function BlogWriter({ data }: { data?: Blog }) {
  const tCommon = useTranslations('common');
  return (
    <div className={`${styles.wrapper}`}>
      <AppLink
        title={data?.user?.name}
        href={`/blogs?user=${data?.user?.slug}`}
        className={`${styles.container}`}
      >
        <UserAvatar
          name={data?.user?.name}
          round={true}
          // colorNumber={index ? index : 0}
          style={{ background: blogBg(0), width: '56px', height: '56px', fontSize: '20px' }}
          avatarClass={`${styles.avatar}  `}
        />
        <UserInfo item={data} showRole={true} userNameClass={styles.userNameClass} />
      </AppLink>
      <Button
        className={`btn squareButton btn-blue ${styles.button}`}
        wrapperStyle={`${styles.buttonWrapper}`}
      >
        دنبال کردن
      </Button>
    </div>
    // <div className={`${styles.art_foot}`}>
    //   <div className={`${styles.art_author_card}`}>
    //     {/* <AppLink
    //       href={`/blog?user=${data?.user?.slug}`}
    //       title={data?.user?.name}
    //       className={`${styles.art_avatar} ${styles.lg}`}
    //     >
    //       {data?.user?.name?.slice(0, 1)?.toUpperCase()}
    //     </AppLink> */}
    //     <UserAvatar/>
    //     <div>
    //       <div className={`${styles.art_foot_label} mono`}>{tCommon('writtenBy')}</div>
    //       <AppLink
    //         href={`/blog?user=${data?.user?.slug}`}
    //         title={data?.user?.name}
    //         className={`${styles.art_author}`}
    //       >
    //         {data?.user?.name}
    //       </AppLink>
    //       <div className={`${styles.art_role}`}>{data?.user?.role}</div>
    //     </div>
    //   </div>
    // </div>
  );
}
